(ns fablo-offers.app.routes
  (:require
   [fablo-offers.app.screens.payment]
   [reitit.frontend :as reitit-fr]
   [reitit.coercion.malli :as rss]))

(def routes
  ["/"
   ["pay/:payment-id"
    {:name :screen/payment}]
   ["offer/:provider-id/:offer-id"
    {:name :screen/offer-2
     :data-source :screen/offer}]
   ["order/:order-id"
    {:name :screen/order}]
   ["claim/:claim-id"
    {:name :screen/claim}]
   ["invite/:order-ref"
    {:name :screen/invite}]
   [":provider-id/:offer-id"
    {:name :screen/offer}]
   [":provider-id/:offer-id/form"
    {:name :screen/offer-form}]
   [":provider-id/:path/:offer-id"
    {:name :screen/offer-path
     :data-source :screen/offer}]
   [":provider-id"
    {:name :screen/offer-main
     :data-source :screen/offer}]])

(def router
  (reitit-fr/router
   routes
   {:conflicts nil
    :data {:coercion rss/coercion}}))
